<template>
	<div class="competition-results">
		<div class="ass-head">
			<i class="iconfont icon-back" @click="$router.go(-1)" title="返回比赛列表"></i>
		</div>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="比赛信息" name="info">
				<competitionInfo ref="competitionInfo" v-if="examGroundId" :examGroundId="examGroundId">
				</competitionInfo>
			</el-tab-pane>
			<el-tab-pane label="题目列表" name="subject">
				<subjectList ref="subjectList" v-if="examGroundId" :examGroundId="examGroundId"></subjectList>
			</el-tab-pane>
			<el-tab-pane label="排行榜" name="rankings">
				<rankings ref="rankings" v-if="examGroundId" :examGroundId="examGroundId"></rankings>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import competitionInfo from "./components/competitionInfo";
	import subjectList from "./components/subjectList";
	import rankings from "./components/rankings";
	import {
		getToken,
		setToken,
		removeToken
	} from '@/utils/auth'
	export default {
		name: "CompetitionResults",
		components: {
			competitionInfo,
			subjectList,
			rankings
		},
		data() {
			return {
				activeName: "info",
				examGroundId: "", // 比赛试卷ID
			}
		},
		created() {
			this.examGroundId = this.$route.query.examGroundId.toString();
		},
		mounted() {
			const activeTab = getToken("simulationGameResultTabs");
			if (activeTab) {
				this.activeName = activeTab;
			}
		},
		methods: {
			handleClick(tab, event) {
				this.activeName = tab.name;
				if (tab.name == "subject") {
					this.$refs.subjectList.setTableHeight();
				} else if (tab.name == "rankings") {
					this.$refs.rankings.setTableHeight();
				}
			}
		},
		beforeRouteLeave(to, from, next) {
			// 在离开当前页面时，保存当前选中的标签页
			if(to.name == "competition"){
				setToken(this.activeName, "simulationGameResultTabs");
			}else{
				removeToken("simulationGameResultTabs");
			}
			next();
		}
	}
</script>

<style lang="scss" scoped>
	.competition-results {
		height: 100%;
		width: 100%;
		background: url(~@/assets/img/mainBg.png) no-repeat;
		background-size: 100% 100%;
		color: #FFF;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 0;

		.ass-head {
			height: 3.8rem;
			line-height: 3.8rem;
			background-color: #252629;
			border-bottom: 0.4rem solid #203B4D;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 1.6rem;

			.icon-back {
				font-size: 2rem;
				cursor: pointer;
				color: #FFF;
				margin-left: 0.4rem;
				margin-right: 3.6rem;
			}
		}

		::v-deep.el-tabs {
			height: calc(100% - 4.2rem);

			.el-tabs__header {
				padding: 0 3.2rem;
				height: 3.2rem;

				.el-tabs__item {
					height: 2.8rem;
					line-height: 2.6rem;
					font-size: 1.12rem;
				}

				.el-tabs__item:focus.is-active.is-focus:not(:active) {
					box-shadow: initial;
				}

				.el-tabs__nav-wrap::after {
					background: none;
				}
			}

			.el-tabs__content {
				height: calc(100% - 3.2rem - 2rem);
				padding: 0 2.24rem 2rem;

				.el-tab-pane {
					height: 100%;
					background-color: rgba(29, 78, 100, 0.8);
					overflow: auto;
					border-radius: 0.4rem;
				}
			}
		}

	}
</style>
